import { socketManager } from './socketManager';
import { errorTracker } from './errorTracker';

export async function initSocketConnection(): Promise<void> {
  try {
    await socketManager.connect();

    // Wait for connection with timeout
    const connected = await socketManager.waitForConnection(10000);

    if (!connected) {
      console.log('Initial connection failed, trying force reset...');

      // Try force reset to clear any stale connections
      socketManager.forceReset();

      // Wait for the reset connection attempt
      const resetConnected = await socketManager.waitForConnection(15000);

      if (!resetConnected) {
        throw new Error('Failed to establish socket connection after reset');
      }
    }
    console.log('Socket connection established');
  } catch (error) {
    errorTracker.captureError(error as Error, 'error', {
      context: 'socket_initialization',
    });
    // Don't throw - let the app continue without real-time features
    console.error('Socket initialization failed:', error);
  }
}
